import { ResponseStructureBlockCombinedProps } from './types';

const usePresenter = (props: ResponseStructureBlockCombinedProps): ResponseStructureBlockCombinedProps => {
  return props;
};

export default usePresenter;
